const EFFECTS = [
  {
    name: 'blur',
    value: '1px'
  },
  {
    name: 'brightness',
    min: 0.5,
    max: 1.5
  },
  {
    name: 'contrast',
    min: 0.4,
    max: 0.8
  },
  {
    name: 'greyscale',
    min: 0.3,
    max: 1
  },
  {
    name: 'hue-rotate',
    min: 1,
    max: 360,
    units: 'deg',
    precision: 0
  },
  // {
  //   name: 'invert',
  //   value: 1
  // },
  {
    name: 'saturate',
    min: 1,
    value: 5
  },
  {
    name: 'sephia',
    min: 0.5,
    max: 1
  },
  {
    name: ''
  }
]


/**
 * Adds a random image effect
 */
import RandomUtils from '@/scripts/utils/random'
export default {

  /**
   * Adds a random image effect for a glitch
   * @param {Object} style the object that holds the style
   */
  RandomEffect(style) {

    let effectIndex = RandomUtils.RandomInt(0, EFFECTS.length)
    let effect = EFFECTS[effectIndex]

    // non empty
    if (effect.name) {

      // use value or random between defined ranged
      let value = (effect.value
        || RandomUtils.RandomNumber(effect.min, effect.max).toFixed(effect.precision || 1))

      // if there is units append
      value = effect.units ? value + effect.units : value
      style.filter = `${effect.name}(${value})`
    }
    return style
  }
}